// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1ubVq","container":"styles_container__2sUCX","title":"styles_title__sr8b0","wrapper":"styles_wrapper__2dPlE","answer":"styles_answer__18ONr"};